import { useDispatch } from 'react-redux';
import GlobalTableGenerator from '../../../components/GlobalTableGenerator';
import { studentTableHeader } from './utils/studentTableHeader';
import { useEffect } from 'react';
import { getPlacementTrackerSessionsStudentDetails } from '../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';

export default function StudentTable({ row, trainerId }) {
  const placementTrackerSessionStudent = useSelector((state) => state.general.placementTrackerSessionStudent.data);
  const placementTrackerSessionStudentLoading = useSelector(
    (state) => state.general.placementTrackerSessionStudent.loading,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (row?.course_available_id)
      dispatch(
        getPlacementTrackerSessionsStudentDetails({
          course_id: row?.course_available_id,
          trainer_id: trainerId,
        }),
      );
  }, [row, trainerId, dispatch]);
  return (
    <GlobalTableGenerator
      TableHeadStyle={{
        bgcolor: '#ccc9c9ff',
        '& .MuiTableCell-root': {
          border: '1px solid #d9d9d9',
        },
      }}
      TableBodyStyle={{
        '& .MuiTableCell-root': {
          border: '1px solid #d9d9d9',
        },
      }}
      columns={studentTableHeader}
      rows={placementTrackerSessionStudent}
      loading={placementTrackerSessionStudentLoading}
    />
  );
}
